module.exports = __webpack_public_path__ + "static/3-03c6b2658174f111272ae2311592a155.jpeg";